export const colorGold = '#cb904d';
export const lightGrey = '#424242';
export const darkGrey = '#333';
export const dividerColor = '#777';
